import {useEnumDictionary} from './useEnumDictionary';

export const useCasingColumnDictionary = (stop?: boolean) => {
    const casingColumnApi = 'CasingColumn';
    const {dictionaryFull, dictionaryOptions, getOptionNameByCode} = useEnumDictionary({
        code: casingColumnApi,
        stop,
    });

    return {
        casingColumnDictionary: dictionaryFull,
        casingColumnOptions: dictionaryOptions,
        getCasingColumnNameByCode: getOptionNameByCode,
    };
};
